import { CircularProgressProps } from '@mui/material';

import * as S from './Spinner.styled';

interface IProps extends CircularProgressProps {
  text?: string;
}

export const Spinner = ({ text, ...rest }: IProps) => (
  <S.Container>
    <S.Spinner {...rest} />
    {text && <S.Text>{text}</S.Text>}
  </S.Container>
);
